import { tap, map, concatMap } from 'rxjs/operators';
import { ApiResponse } from '@core/models/api-response.model';
import { Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Pagination } from '@core/models/pagination.model';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { Injectable } from '@angular/core';
import { WhatsappCampaign } from '@core/models/whatsapp-campaign.model';

@Injectable()
export class WhatsappCampaignDataService extends DefaultDataService<WhatsappCampaign>  {

  pagination: Pagination;
  messages$ = new Subject<any[]>();

  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator) {
      super('WhatsappCampaign', http, httpUrlGenerator, { root: '' });
  }

  getWithQuery(pageParam: string): Observable<WhatsappCampaign[]>{
    return this.http.get<ApiResponse>(`/whatsappcampaign${pageParam}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  getSetting(): Observable<any> {
    return this.http.get<ApiResponse>(`/whatsappcampaign/setting`).pipe(
      map(res => res.data.rows)
    );
  }

  updateSetting(id: number, data: any) {
    return this.http.put<ApiResponse>(`/whatsappcampaign/setting/${id}`, data).pipe(
      tap(res => this.messages$.next(res.message))
    );
  }

  private paginationInit(res: any) {
    if(res) {
      this.pagination = res.data.paginations;
    }
  }
}